import React from 'react';
import { ChevronDown } from 'lucide-react';
import { cn } from '@/lib/utils';

interface FloatingArrowProps {
  targetSelector: string;
  className?: string;
  text?: string;
}

export const FloatingArrow: React.FC<FloatingArrowProps> = ({
  targetSelector,
  className,
  text
}) => {
  const [position, setPosition] = React.useState<{ top: number; left: number } | null>(null);

  React.useEffect(() => {
    const updatePosition = () => {
      const targetElement = document.querySelector(targetSelector);
      if (targetElement) {
        const rect = targetElement.getBoundingClientRect();
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
        
        setPosition({
          top: rect.top + scrollTop - 43, // 箭头在目标元素上方80px
          left: rect.left + scrollLeft + rect.width / 2 - 60 // 居中对齐，考虑箭头组件宽度
        });
      }
    };

    // 初始计算位置
    updatePosition();

    // 监听窗口大小变化和滚动
    window.addEventListener('resize', updatePosition);
    window.addEventListener('scroll', updatePosition);

    // 使用 MutationObserver 监听DOM变化
    const observer = new MutationObserver(updatePosition);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class']
    });

    return () => {
      window.removeEventListener('resize', updatePosition);
      window.removeEventListener('scroll', updatePosition);
      observer.disconnect();
    };
  }, [targetSelector]);

  if (!position) return null;

  return (
    <div
      className={cn(
        "fixed z-50 pointer-events-none",
        className
      )}
      style={{
        top: position.top,
        left: position.left,
      }}
    >
      <div className="flex flex-col items-center animate-bounce">
        <div className="text-black text-sm font-medium mb-0 whitespace-nowrap drop-shadow-lg">
          {text}
        </div>
        <ChevronDown className="w-6 h-6 text-black drop-shadow-lg animate-pulse" />
      </div>
    </div>
  );
};